/**
 * Accord en nombre d'un compte entier, règle française : singulier pour 0 et 1,
 * pluriel à partir de 2 (« 0 point », « 1 point », « 2 points »).
 */
export function plural(n: number, singulier: string, pluriel: string = `${singulier}s`): string {
  return `${n} ${Math.abs(n) >= 2 ? pluriel : singulier}`;
}
